"use client";

import { Tab } from "rizzui";
import { ReactNode } from "react";
import ProjectPage from "../project/ProjectPage";
import UnitTypeListingPage from "../unit-types/UnitTypeListingPage";
import ProjectCategoryListingPage from "../project-category/ProjectCategoryListingPage";
import DeveloperListingPage from "../developer/DeveloperListingPage";
import PlacesListingPage from "../places/PlacesListingPage";
import LocationListingPage from "../location/LocationListingPage";

const tabs: { label: string; content: ReactNode }[] = [
  { label: "All Projects", content: <ProjectPage /> },
  { label: "All Districts", content: <LocationListingPage /> },
  { label: "Unit Types", content: <UnitTypeListingPage /> },
  { label: "Project Category", content: <ProjectCategoryListingPage /> },
  { label: "Developer", content: <DeveloperListingPage /> },
  { label: "Places", content: <PlacesListingPage /> },
];

export default function ProjectListingPage() {
  return (
    <Tab>
      <Tab.List>
        {tabs.map((tab, index) => (
          <Tab.ListItem key={index}>{tab.label}</Tab.ListItem>
        ))}
      </Tab.List>
      <Tab.Panels>
        {tabs.map((tab, index) => (
          <Tab.Panel key={index}>{tab.content}</Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab>
  );
}
